export default __webpack_public_path__ + "static/media/person-outline.83b20036.svg";